/**
 * vue-router 設定
 *
 * 還原自 index.js（pretty 檔 L3163-L3168）。三條路由與 history 模式
 * 與原始 bundle 完全一致。
 *
 * 注意：history 模式需要後端把這三條路徑都回傳 index.html。
 * order_server.js 已有對應處理：'/'、'/products'、'/checkout' 三條
 * app.get 都 sendFile index.html。
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Products from '../views/Products.vue'
import Checkout from '../views/Checkout.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/products', name: 'products', component: Products },
  { path: '/checkout', name: 'checkout', component: Checkout }
]

export default new VueRouter({
  mode: 'history',
  base: '/',
  routes
})
